import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl72ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    acceptedFinancialReport: yup
      .string()
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktDSDate: yup.date().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPraktDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocIsologismos: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    usageFromDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date("2016-07-07"),
        t("Η ημερομηνία πρέπει να είναι πριν από τις 07/07/2016")
      )
      .test(
        "date",
        t("Η ημερομηνία πρέπει να είναι πριν από την ημερομηνία εώς χρήση"),
        function (value: Date | null, context) {
          const { usageToDate } = context.parent;
          return value ? value < usageToDate : false;
        }
      ),
    usageToDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date("2016-07-07"),
        t("Η ημερομηνία πρέπει να είναι πριν από τις 07/07/2016")
      )
      .test(
        "date",
        t("Η ημερομηνία πρέπει να είναι μετά την ημερομηνία από χρήση"),
        function (value: Date | null, context) {
          const { usageFromDate } = context.parent;
          return value ? value > usageFromDate : false;
        }
      ),
    eDoy: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null))
      .test(
        "eDoy",
        t(
          "Εάν επιθυμείτε να εισάγετε e-Παράβολο πρέπει να συμπληρώσετε μόνο το πεδίο 'Κωδικός Αριθμός e-Παραβόλου' και να αφήσετε τα υπόλοιπα κενά."
        ),
        function (value, context) {
          const { fudocDoy, doyDate, doySn, d13_code } = context.parent;
          return !(value && (!!fudocDoy || !!doyDate || !!doySn || !!d13_code));
        }
      ),
    fudocDoy: yup
      .string()
      .nullable()
      .transform((_, val) => (val !== "" ? val : null)),
    doyDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .nullable()
      .transform((_, originalValue) =>
        originalValue ? new Date(originalValue) : null
      ),
    doySn: yup
      .string()
      .transform((_, val) => (val !== "" ? val : null))
      .nullable()
      .test(
        "check-6-digits",
        t("Το πεδίο πρέπει να περιέχει μέχρι 6 ψηφία"),
        (value) =>
          value === undefined ||
          value === null ||
          /^\d{1,6}$/.test(value.toString())
      ),
    d13_code: yup.object().nullable().default(null),
  });
};
